import React, { useState, useEffect } from 'react'
import { Row, Col } from 'antd'
import _ from 'lodash'
import cx from 'classnames'
import styles from './ImageFunctionRow.css'
import {
  ImageFunction,
  handleImageFileUpdate,
  handleImageFileFinish
} from '../../ProductListingBaseForm/Spec/AttributeInfo/ProductAttribute/AttributeTable'
import ImageUploaderFieldContainer from '../../Common/ImageUploader/ImageUploaderField'
import { Button, Modal } from '@vzmi/shp_shared_compo'
import { DetailTable } from '../../Common/ItemIdClipBoard/ItemSpecDetailTable'
import { Field } from '../../../Common/forms'
import DistinctSizesUploaderField from '../../Common/ImageUploader/DistinctSizesUploaderField/DistinctSizesUploaderField'
import { IMAGE_UPLOADER_MAX_FILE } from '../../Shared'
import { validateModelImages } from '../../Common/ProposalForm/Shared/validation/fieldLevelValidator'

const ImageFunctionRow = props => {
  const {
    enableShare,
    enableSync,
    isImageSynced,
    isImageShared,
    isImageSharedTagContent,
    isNoModelsListing,
    isExtraModel,
    readOnly,
    hasDistinctSizesUploader,
    activePrimaryImageURL,
    shareImageFieldName = 'listing.shareMediaBetweenModels',
    syncImageFieldName = 'listing.syncProductImages',
    currentModelField,
    imagesFieldName,
    firstOrderImagesFieldName,
    productIds,
    modelSpecHeader,
    itemSpecHeader,
    modelSpecValue,
    defaultShowUploader = true,
    itemSpecValues = [],
    handleOrderImageChange,
    withCustomCols,
    withProductIdCol,
    withCustomProductIdCol,
    customCols,
    customProductIdCol,
    modelIndex,
    isHiddenCounterOnInvalid,
    isSpecSelected,
    ...otherProps
  } = props

  const [isUploading, setIsUploading] = useState(false)
  const [showUploader, setShowUploader] = useState(defaultShowUploader)
  const [showProductIdsModal, setShowProductIdsModal] = useState(false)
  const isTwoLayerListing = !_.isEmpty(itemSpecHeader)

  useEffect(
    () => {
      if (
        (!enableShare && isImageShared) ||
        (isHiddenCounterOnInvalid || !isSpecSelected)
      ) {
        setShowUploader(false)
      }
    },
    [enableShare, isImageShared, isHiddenCounterOnInvalid, isSpecSelected]
  )

  const handleExpandImageClick = () => {
    if (isHiddenCounterOnInvalid && !isSpecSelected) {
      return
    }

    setShowUploader(!showUploader)
  }

  return (
    <>
      <Row
        key='imageFunctionRow'
        type='flex'
        align='top'
        justify='space-between'
        className={cx(
          styles.imageFunctionRow,
          styles.customImageFunctionRow,
          // 雙層屬性賣場每一個第一層屬性的第一列
          { [styles.specFirstRow]: isTwoLayerListing && modelIndex === 0 }
        )}
        {...otherProps}
      >
        {/* 商品編號 */}
        {withProductIdCol && (
          withCustomProductIdCol
            ? customProductIdCol(props)
            : (
              <Col
                span={4}
                key='productIds'
              >
                {
                  productIds.length <= 1
                    ? productIds[0]
                    : (
                      <>
                        <Button
                          link
                          type='button'
                          size='medium'
                          onClick={() => setShowProductIdsModal(!showProductIdsModal)}
                        >
                          所有商品編號
                        </Button>
                        <Modal
                          closable
                          disableFooter
                          destroyOnClose
                          title='所有商品編號'
                          visible={showProductIdsModal}
                          onCancel={() => setShowProductIdsModal(false)}
                          width={420}
                        >
                          <DetailTable
                            data={
                              productIds.map((productId, idx) => ({
                                key: idx,
                                productId,
                                modelSpecValue,
                                itemSpecValue: itemSpecValues[idx]
                              }))
                            }
                            columns={[
                              {
                                title: '商品編號',
                                dataIndex: 'productId',
                                className: styles.items,
                                width: 130
                              },
                              {
                                title: modelSpecHeader,
                                dataIndex: 'modelSpecValue',
                                className: styles.productNo,
                                width: 130
                              },
                              {
                                title: itemSpecHeader,
                                dataIndex: 'itemSpecValue',
                                className: styles.productNo,
                                width: 130
                              }
                            ]}
                          />
                        </Modal>
                      </>
                    )
                }
              </Col>
            )
        )}
        {/* 商品圖片 */}
        <Col
          // 無屬性且沒有自訂欄位
          span={(!withCustomCols && isNoModelsListing && !isExtraModel) ? 16 : 4}
          key='syncProductImages'
        >
          {(
            // 兼容修改賣場資訊裡的修改圖片商品是展開的，在雙層屬性賣場中第二層只有第一筆會顯示圖片的 UI
            (modelIndex === 0 || _.isUndefined(modelIndex)) ||
            // 單層屬性每一列都要顯示圖片
            (!isNoModelsListing && !isTwoLayerListing)
          ) && (
            <Field
              onShareImagesClick={checked => {
                if (checked && !showUploader) {
                  setShowUploader(true)
                }
              }}
              shareImageFieldName={shareImageFieldName}
              isImageShared={isImageShared}
              isImageSharedTagContent={isImageSharedTagContent}
              enableShare={enableShare}
              syncImageFieldName={syncImageFieldName}
              isImageSynced={isImageSynced}
              isHiddenCounterOnInvalid={isHiddenCounterOnInvalid}
              enableSync={enableSync}
              readOnly={readOnly}
              name={imagesFieldName}
              expanded={showUploader}
              component={ImageFunction}
              maxFile={IMAGE_UPLOADER_MAX_FILE}
              onExpandImageClick={handleExpandImageClick}
            />
          )}
        </Col>
        {!withCustomCols && (
          <>
            <Col
              span={4}
              key='modelSpecValue'
            >
              <p>{modelSpecValue}</p>
            </Col>
            <Col
              span={12}
              key='itemSpecValues'
            >
              {itemSpecValues.join(' / ')}
            </Col>
          </>
        )}
        {withCustomCols && customCols(props)}
      </Row>
      {
        showUploader && (
          <Row
            className={styles.uploaderRow}
            key='uploaderRow'
          >
            <Col offset={4}>
              {/* 上傳個別尺寸 */}
              {
                hasDistinctSizesUploader && activePrimaryImageURL && (
                  <Field
                    readOnly={readOnly}
                    disabled={isUploading}
                    activePrimaryImageURL={activePrimaryImageURL}
                    name={firstOrderImagesFieldName}
                    onUpdate={handleImageFileUpdate}
                    onFinish={handleImageFileFinish}
                    component={DistinctSizesUploaderField}
                  />
                )
              }
              {/* 上傳圖片 */}
              <Field
                disabled={readOnly}
                name={imagesFieldName}
                component={ImageUploaderFieldContainer}
                setIsUploading={setIsUploading}
                onChange={handleOrderImageChange}
                onUpdate={handleImageFileUpdate}
                onFinish={handleImageFileFinish}
                validate={validateModelImages}
              />
            </Col>
          </Row>
        )
      }
    </>
  )
}

export default ImageFunctionRow
